// export const grades = [
//     {
//         name: 'Kindergarten',
//         title: 'Kindergarten',
//     },
//     {
//         name: 'FoundationPrep',
//         title: 'Foundation/ Prep',
//     },
//     {
//         name: 'Grade1',
//         title: 'Grade 1',
//     },
//     {
//         name: 'Grade2',
//         title: 'Grade 2',
//     },
//     {
//         name: 'Grade3',
//         title: 'Grade 3',
//     },
//     {
//         name: 'Grade4',
//         title: 'Grade 4',
//     },
//     {
//         name: 'Grade5',
//         title: 'Grade 5',
//     },
//     {
//         name: 'Grade6',
//         title: 'Grade 6',
//     },
//     {
//         name: 'Year7',
//         title: 'Year 7',
//     },
//     {
//         name: 'Year8',
//         title: 'Year 8',
//     },
//     {
//         name: 'Year9',
//         title: 'Year 9',
//     },
//     {
//         name: 'Year10',
//         title: 'Year 10',
//     },
//     {
//         name: 'Year11',
//         title: 'Year 11',
//     },
//     {
//         name: 'Year12',
//         title: 'Year 12',
//     },
// ];

export const grades = [
    {
        name: 'Kindergarten',
        title: 'Kindergarten',
    },
    {
        name: 'FoundationPrep',
        title: 'Foundation/Prep',
    },
    {
        name: 'PrimarySchool',
        title: 'Primary School',
    },
    {
        name: 'SecondarySchool',
        title: 'Secondary School',
    },
];
